import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { createTag, deleteTag, listTags, updateTag } from './tagsAdminApi'
import { TagCreateInput, TagFilters, TagUpdateInput } from './tagsAdminModel'

const ADMIN_LIST_KEY = ['tagsAdmin', 'list'] as const

export const useTagsListQuery = (filters: TagFilters) => {
  return useQuery({
    queryKey: [...ADMIN_LIST_KEY, filters],
    queryFn: () => listTags(filters),
    keepPreviousData: true,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load tags' })
    },
  })
}

export const useCreateTagMutation = () => {
  const queryClient = useQueryClient()
  return useMutation((input: TagCreateInput) => createTag(input), {
    onSuccess: () => {
      queryClient.invalidateQueries(ADMIN_LIST_KEY)
      notification.success({ message: 'Tag created' })
    },
    onError: (err) => {
      const description = err instanceof Error ? err.message : undefined
      notification.error({ message: 'Failed to create tag', description })
    },
  })
}

export const useUpdateTagMutation = () => {
  const queryClient = useQueryClient()
  return useMutation((input: TagUpdateInput) => updateTag(input), {
    onSuccess: () => {
      queryClient.invalidateQueries(ADMIN_LIST_KEY)
      notification.success({ message: 'Tag updated' })
    },
    onError: (err) => {
      const description = err instanceof Error ? err.message : undefined
      notification.error({ message: 'Failed to update tag', description })
    },
  })
}

export const useDeleteTagMutation = () => {
  const queryClient = useQueryClient()
  return useMutation((tagId: string) => deleteTag(tagId), {
    onSuccess: () => {
      queryClient.invalidateQueries(ADMIN_LIST_KEY)
      notification.success({ message: 'Tag deleted' })
    },
    onError: (err) => {
      const description = err instanceof Error ? err.message : undefined
      notification.error({ message: 'Failed to delete tag', description })
    },
  })
}
